function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Commnt from '@/components/user/accessCommon';
export default {
  name: 'FormBox',
  props: ['total'],
  components: {
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    },
    dateQuarter: function dateQuarter() {
      return import('@/components/form-common/select-dateQuarter');
    },
    conditionDialog: function conditionDialog() {
      return import('@/components/develop/conditionDialog');
    }
  },
  data: function data() {
    return {
      pickerOptions: this.$pickerOptionsTimeEle,
      showForm: false,
      showText: '展开',
      activeIndex: 'created_at',
      timeVal: [],
      tableFrom: {
        time: '',
        date: '',
        times: '',
        type: '',
        period: '',
        test_uid: '',
        exportType: 0
      },
      additional_search: [],
      departmentList: [],
      periodOptions: Commnt.periodOption,
      type: 0,
      statusOptions: Commnt.statusOptions,
      activeDepartment: {},
      userList: [],
      checkList: [],
      sortIndex: '',
      sortList: [{
        name: '升序',
        value: 'asc'
      }, {
        name: '降序',
        value: 'desc'
      }, {
        name: '默认排序',
        value: ''
      }],
      timeSearch: [{
        name: '创建时间',
        value: 'created_at'
      }, {
        name: '修改时间',
        value: 'updated_at'
      }],
      viewSearch: [{
        field: 'frame',
        title: '部门',
        type: 'frame_id'
      }, {
        field: 'check_uid',
        title: '考核人',
        type: 'check_uid'
      }, {
        field: 'status',
        title: '考核状态',
        type: 'select',
        options: Commnt.statusOptions
      }],
      title: '',
      dateArray: [{
        value: 1,
        type: 'week',
        text: '选择周',
        format: 'yyyy 第 WW 周'
      }, {
        value: 2,
        type: 'month',
        text: '选择月份',
        format: 'yyyy-MM'
      }, {
        value: 4,
        type: ''
      }, {
        value: 5,
        type: ''
      }, {
        value: 3,
        type: 'year',
        text: '选择年份',
        format: 'yyyy'
      }],
      quarterBtn: false,
      halfYearBtn: false
    };
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    }
  },
  watch: {
    lang: function lang() {
      this.setOptions();
    }
  },
  methods: {
    setOptions: function setOptions() {},
    // 时间段选择
    selectChange: function selectChange() {
      this.timeVal = '';
    },
    onShow: function onShow() {
      this.$store.state.business.conditionDialog = true;
    },
    dropdownSearch: function dropdownSearch() {
      this.$emit('openAssessed');
    },
    // 高级筛选样式
    saveCondition: function saveCondition(data) {
      this.additional_search = this.$store.state.business.fieldOptions.list;
      var obj = {};
      this.additional_search.map(function (item) {
        obj[item.field] = item.option;
      });
      this.tableFrom.exportType = 0;
      this.tableFrom = _objectSpread(_objectSpread({}, this.tableFrom), obj);
      this.$emit('confirmData', this.tableFrom);
    },
    handleClick: function handleClick(item, index) {
      this.tableFrom.sort_field = item.value;
      this.activeIndex = item.value;
      this.tableFrom.exportType = 0;
      this.$emit('confirmData', this.tableFrom);
    },
    sortFn: function sortFn(item, index) {
      this.tableFrom.sort_value = item.value;
      this.sortIndex = item.value;
      this.tableFrom.exportType = 0;
      this.$emit('confirmData', this.tableFrom);
    },
    // 重置
    reset: function reset() {
      this.timeVal = [];
      this.tableFrom = {
        time: '',
        data: '',
        times: '',
        type: '',
        status: '',
        period: '',
        frame: '',
        test_uid: '',
        check_uid: '',
        exportType: 0
      };
      this.departmentList = [];
      this.userList = [];
      this.checkList = [];
      this.additional_search = [];
      var data = {
        list: [],
        type: '',
        additional_search_boolean: '0'
      };
      this.$store.commit('uadatefieldOptions', data);
      this.$emit('confirmData', 'reset');
    },
    cardTag: function cardTag(type, index) {
      if (type === 1) {
        this.departmentList.splice(index, 1);
        this.tableFrom.frame.splice(index, 1);
      } else if (type === 2) {
        this.userList.splice(index, 1);
        this.tableFrom.test_uid.splice(index, 1);
      } else {
        this.tableFrom.check_uid.splice(index, 1);
        this.checkList.splice(index, 1);
      }
      this.handleConfirm();
    },
    openFn: function openFn() {
      if (this.showForm === false) {
        this.showText = '收起';
        this.showForm = true;
      } else if (this.showForm === true) {
        this.showText = '展开';
        this.showForm = false;
      }
    },
    // 选择时间区域
    onchangeTime: function onchangeTime(e) {
      if (e == null) {
        this.tableFrom.time = '';
        this.tableFrom.times = '';
      } else {
        this.timeVal = e;
        if (this.tableFrom.period === 4 || this.tableFrom.period === 5) {
          this.$refs.dateQuarter.showValue = '';
        }
        this.tableFrom.time = this.timeVal[0] + '-' + this.timeVal[1];
        this.tableFrom.times = this.timeVal[0] + '-' + this.timeVal[1];
        this.tableFrom.date = '';
      }
      this.handleConfirm();
    },
    // 确认
    handleConfirm: function handleConfirm() {
      this.tableFrom.exportType = 0;
      this.confirmData();
    },
    handleExport: function handleExport() {
      this.$emit('getExportData');
    },
    confirmData: function confirmData() {
      this.$emit('confirmData', this.tableFrom);
    },
    gettype: function gettype() {
      if (this.type == 1) {
        return this.departmentList;
      } else if (this.type == 2) {
        return this.userList;
      } else {
        return this.checkList;
      }
    },
    // 选择成员回调
    getSelectList: function getSelectList(data, type) {
      if (type === 2) {
        var testUid = [];
        data.forEach(function (item) {
          testUid.push(item.value);
        });
        this.tableFrom.test_uid = testUid;
        this.userList = data;
      } else if (type === 3) {
        var checkUid = [];
        data.forEach(function (item) {
          checkUid.push(item.value);
        });
        this.tableFrom.check_uid = checkUid;
        this.checkList = data;
      }
      this.handleConfirm();
    },
    getPeriodText: function getPeriodText(id) {
      var txt = Commnt.getPeriodText(id);
      return txt;
    },
    getStatusText: function getStatusText(id) {
      var txt = Commnt.getStatusText(id);
      return txt;
    },
    changePeriod: function changePeriod(e) {
      var _this = this;
      // 切换季度半年考核
      if (e == 4) {
        this.quarterBtn = true;
        this.halfYearBtn = true;
        this.$nextTick(function () {
          _this.$refs.dateQuarter.showValue = '';
        });
      } else if (e == 5) {
        this.quarterBtn = true;
        this.halfYearBtn = false;
        this.$nextTick(function () {
          _this.$refs.dateQuarter.showValue = '';
        });
      } else {
        this.quarterBtn = false;
      }
      if (e === '') {
        this.tableFrom.date = '';
      } else {
        this.timeVal = [];
        this.tableFrom.time = '';
        this.tableFrom.times = '';
      }
      this.handleConfirm();
    },
    getDateValue: function getDateValue(e) {
      this.timeVal = [];
      if (!e) {
        this.tableFrom.date = '';
      } else {
        if (this.tableFrom.period == 1) {
          this.tableFrom.date = this.$moment(this.tableFrom.time).format('YYYY-MM-DD 00:00:00');
        } else if (this.tableFrom.period == 2) {
          this.tableFrom.date = this.$moment(this.tableFrom.time).format('YYYY-MM-DD 00:00:00');
        } else if (this.tableFrom.period == 3) {
          this.tableFrom.date = this.$moment(this.tableFrom.time).format('YYYY-MM-DD 00:00:00');
        }
      }
      this.handleConfirm();
    },
    getQuarterDate: function getQuarterDate(data) {
      this.tableFrom.date = this.getQuarterTime(this.tableFrom.period, data);
      this.timeVal = [];
      this.tableFrom.times = '';
      this.tableFrom.time = '';
      this.handleConfirm();
    },
    getQuarterTime: function getQuarterTime(type, time) {
      if (!time) return false;
      var str = '';
      var timeArr = time.split('-');
      var year = timeArr[0];
      var month = timeArr[1];
      if (type === 5) {
        if (month === '01') {
          str = year + '-01-01 00:00:00';
        } else if (month === '02') {
          str = year + '-04-01 00:00:00';
        } else if (month === '03') {
          str = year + '-07-01 00:00:00';
        } else if (month === '04') {
          str = year + '-10-01 00:00:00';
        }
      } else if (type === 4) {
        if (month === '01') {
          str = year + '-01-01 00:00:00';
        } else if (month === '02') {
          str = year + '-07-01 00:00:00';
        }
      }
      return str;
    }
  }
};